import { grafSignService } from 'services/grafSignService';
import useAPIError from './useThrowAsyncError';
import { useEffect, useState } from 'react';

export type GrafSign = {
    _id: string;
    points: any[];
    imageBase64: string;
    default: boolean;
    description: string;
};

const useGrafSign = () => {
    const { addError } = useAPIError();
    const [grafSigns, setGrafSigns] = useState<GrafSign[]>([]);

    const addSign = async (body: any) => {
        await grafSignService.addSign(body).catch((err: any) => {
            throw addError(err.message, err.details);
        });
    };

    const updateSign = async (id: string, body: any) => {
        try {
            await grafSignService.updateSign(id, body);
        } catch (err: any) {
            throw addError(err.message, err.details);
        }
    };

    const fetchGrafSigns = async () => {
        const response = await grafSignService.getSigns().catch((err: any) => {
            return [];
            //throw addError(err.message, err.details);
        });
        setGrafSigns(
            response.map((sign: GrafSign) => ({
                ...sign,
                points: sign.points.map((e: any) => {
                    delete e._id;
                    if (e.time) {
                        e.time = new Date(e.time).getTime();
                    }
                    return e;
                })
            }))
        );
    };

    const clearSigns = async () => {
        setGrafSigns([]);
    };

    useEffect(() => {
        fetchGrafSigns();
    }, []);

    return {
        addSign,
        updateSign,
        grafSigns,
        clearSigns,
        fetchGrafSigns
    };
};

export default useGrafSign;
